// extracted by mini-css-extract-plugin
export default {"container":"Splash_container__opigx","logo":"Splash_logo__hjE9d","pulse":"Splash_pulse__EhTKm"};